import sales from './sales/routes';
import product from './product/routes';
import service from './service/routes';
import shift from './shift/routes';
import { calendarRoute } from '@/views/calendar_route';

const routes = [
  {
    path: '/',
    alias: '/home-dashboard',
    name: 'Home',
    icon: 'mdi-home',
    component: () => import('./Dashboard.vue'),
  },
  {
    path: '/multiClientTest',
    name: 'Multi Client Test',
    component: () => import('./templates/ReportTemplate.vue'),
  },
  sales,
  product,
  service,
  shift,
  calendarRoute,
];

export default routes;
